export const errors = {
    NO_BROWSER_WEB3: "No Web3 provider exposed by browser.",
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2Vycm9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxNQUFNLENBQUMsTUFBTSxNQUFNLEdBQUc7SUFDbEIsZUFBZSxFQUFFLHNDQUFzQztDQUMxRCxDQUFDIn0=